<template lang="pug">
b-modal#webhook-form(
  ref="modal"
  title="Crear Webhook"
  ok-title="Crear"
  cancel-title="Cancelar"
  @ok="onSubmit"
  @show="resetForm"
)
  b-form(@submit.stop.prevent="onSubmit")
    b-form-group(
      :invalid-feedback="getInvalidFeedback($v.form.webhookUrl)"
      label="URL"
      description="URL donde se enviara el webhook"
    )
      b-form-input(
        v-model="form.webhookUrl"
        maxlength="256"
        :state="$v.$dirty ? !$v.form.webhookUrl.$invalid : null"
        placeholder="https://example.com/webhook"
      )
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { isUrl, getInvalidFeedback } from '../../shared/customValidations'
export default {
  name: 'ApiKeyFrom',
  data () {
    return {
      loading: false,
      form: {
        webhookUrl: ''
      }
    }
  },
  validations: {
    form: {
      webhookUrl: { required, isUrl }
    }
  },
  methods: {
    getInvalidFeedback,
    ...mapActions(['createWebhook']),
    resetForm () {
      this.form = {
        webhookUrl: ''
      }
      this.$v.$reset()
    },
    async onSubmit (event) {
      event.preventDefault()
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      }
      this.loading = true
      try {
        await this.createWebhook(this.form)
        this.loading = false
        this.$bvToast.toast('Webhook creado exitosamente', {
          title: 'Éxito',
          variant: 'success'
        })
        this.$refs.modal.hide()
        this.$emit('done')
      } catch (error) {
        this.loading = false
        this.$bvToast.toast('Error al crear Webhook', {
          title: 'Error',
          variant: 'danger'
        })
      }
    }
  }
}
</script>

<style lang="scss">
#api-key-form {
  .form-control:focus {
    color: #495057;
    background-color: #fff;
    border-color: #869099;
    outline: 0;
    box-shadow: 0 0 0 0.2rem #ced4da;
  }
}
</style>
